import { DatePicker, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import Modal from "antd/es/modal/Modal";
import { Field, Form, Formik } from "formik";
import { svg } from "../../../../../Assets/svg";
import { dayjsFormat } from "../../../../../helpers/utils";
import dayjs from "dayjs";
import { dispatchFormValidation } from "../../../../validationSchema/common";
import { BtnLoader } from "../../../../../Components/Components";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { UpdateOrderDispatchDetailsAPI } from "../../../../Redux/orders";
import { useParams } from "react-router-dom";

const DispatchDetailsModal = ({
  visible,
  setIsModalVisible,
  isDispatchDetailsData,
  setIsDispatchDetailsData,
  onSave,
}: any) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { updateDispatchDetailsLoading } = useAppSelector(
    (state: RootState) => state?.loading,
  );
 
  const handleSave = (values: any) => {
    const payload = {
      order_id: id,
      load_id: isDispatchDetailsData?._id,
      dispatched_at: values?.dispatch_date?.toISOString(),
      tracking_number: values?.tracing_number,
      transporter: values?.transporter,
      vehicle_info: values?.vehicle_info,
      note: values?.dispatch_note || "",
    };
    const handleSuccessStstus = () => {
      setIsModalVisible(null);
    };
    if (onSave) {
      onSave(payload, handleSuccessStstus);
    } else {
      dispatch(UpdateOrderDispatchDetailsAPI(payload, handleSuccessStstus));
    }
  };
  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Please Provide {isDispatchDetailsData?.title} Details
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={updateDispatchDetailsLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="submitDispatchForm"
            disabled={updateDispatchDetailsLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
          >
            {updateDispatchDetailsLoading ? <BtnLoader /> : "Save"}
          </button>
        </div>
      }
      className="custom-modal"
    >
      <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
        Please enter the dispatch details to proceed with the shipment. This
        information will be shared with the client or distributor for tracking
        and record purposes.
      </p>
      <Formik
        initialValues={{
          dispatch_date: isDispatchDetailsData?.dispatched_details
            ?.dispatched_at
            ? dayjs(isDispatchDetailsData.dispatched_details.dispatched_at)
            : null,
          tracing_number:
            isDispatchDetailsData?.dispatched_details?.tracking_number || "",
          transporter:
            isDispatchDetailsData?.dispatched_details?.transporter || "",
          vehicle_info:
            isDispatchDetailsData?.dispatched_details?.vehicle_info || "",
          dispatch_note: isDispatchDetailsData?.dispatched_details?.note || "",
        }}
        validationSchema={dispatchFormValidation}
        onSubmit={handleSave}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          setFieldValue,
        }: any) => {
          return (
            <Form id="submitDispatchForm" className="page-form" onSubmit={handleSubmit}>
              <div className="row gy-3">
                <div className="col-md-6">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">
                      Dispatch Date
                    </label>
                    <DatePicker
                      suffixIcon={svg?.calenderIcon}
                      className="w-100 form-control-lg"
                      size="large"
                      format={dayjsFormat}
                      placeholder="Dispatch Date"
                      value={
                        values?.dispatch_date
                          ? dayjs(values.dispatch_date)
                          : null
                      }
                      onChange={(date) =>
                        setFieldValue("dispatch_date", date ? date : null)
                      }
                      // disabled={disabled}
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                    />
                    {errors?.dispatch_date && touched?.dispatch_date && (
                      <div className="text-danger fs-8">
                        {errors?.dispatch_date}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">
                      Tracking Number
                    </label>
                    <Field
                      name="tracing_number"
                      className="form-control form-control-lg"
                      value={values?.tracing_number}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Tracking Number"}
                      as={Input}
                      onChange={(e: any) => {
                        setFieldValue("tracing_number", e.target.value);
                      }}
                    />
                    {errors?.tracing_number && touched?.tracing_number && (
                      <div className="text-danger fs-8">
                        {errors?.tracing_number}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">Transporter</label>
                    <Field
                      name="transporter"
                      className="form-control form-control-lg"
                      value={values?.transporter}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Transporter Name"}
                      as={Input}
                      onChange={(e: any) => {
                        setFieldValue("transporter", e.target.value);
                      }}
                    />
                    {errors?.transporter && touched?.transporter && (
                      <div className="text-danger fs-8">
                        {errors?.transporter}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">Vehicle Info</label>
                    <Field
                      name="vehicle_info"
                      className="form-control form-control-lg"
                      value={values?.vehicle_info}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Vehicle Information"}
                      as={Input}
                      onChange={(e: any) => {
                        setFieldValue("vehicle_info", e.target.value);
                      }}
                    />
                    {errors?.vehicle_info && touched?.vehicle_info && (
                      <div className="text-danger fs-8">
                        {errors?.vehicle_info}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">
                      Dispatch Note
                    </label>
                    <TextArea
                      name="dispatch_note"
                      className="form-control form-control-lg"
                      value={values?.dispatch_note}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Dispatch Note"}
                      onChange={(e: any) => {
                        setFieldValue("dispatch_note", e.target.value);
                      }}
                    />
                    {errors?.dispatch_note && touched?.dispatch_note && (
                      <div className="text-danger fs-8">
                        {errors?.dispatch_note}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default DispatchDetailsModal;
